import Member from "./Member";

function MemberList(params) {
    const members = params.members || [];
    if (members.length === 0) return <span style={{ color: '#9ca3af', marginLeft: '5px' }}>—</span>;

    return (
        <div style={{
            display: 'inline-flex',
            flexWrap: 'wrap',
            gap: '5px',
            marginLeft: '8px',
            verticalAlign: 'middle'
        }}>
            {members.map((m, index) => (
                <Member member={m} key={m?.id || index} />
            ))}
        </div>
    );
}

export default MemberList;